// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__qMDB_","log":"ModalInventoryLogs_log__2OyKD","date":"ModalInventoryLogs_date__3oyF8","userName":"ModalInventoryLogs_userName__3T502"};